import React, { FC } from 'react';

import { Grid } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';

import { IAdminEvent } from '../../../../../store/admin/events/store';

import Input from '../../../../../components/Input';
import Tooltip from '../../../../../components/Tooltip';
import YesNoSwitch from '../../../../../components/YesNoSwitch';

interface IProps {
  errors: any;
  event: IAdminEvent;
  round: any;
  setValue: (name: string) => (event: any) => void;
  toggleValue: (field: string) => (event: any) => void;

  values: any;
}

const TeeSheetSetup: FC<IProps> = props => {
  const { event, values, errors, setValue, toggleValue } = props;

  return (
    <Paper elevation={1} className="paper tee-sheet-setup">
      <div className="title__container override">
        <h3 className="title-tooltip override">Tee sheet setup</h3>

        <Tooltip
          classes={{ fab: 'tooltip-fab--shift-top-2dot5' }}
          sectionKey="ROUND_BASICS.TEE_SHEET_SETUP"
        />
      </div>

      <Grid className="grid" container={true} spacing={2}>
        <Grid className="grid-item shotgun-input" item={true} xs={12}>
          <span className="shotgun-input__label">IS THIS A SHOTGUN START?</span>

          <Tooltip
            classes={{ fab: 'tooltip-fab--shift-top-2' }}
            sectionKey="ROUND_BASICS.SHOTGUN_START"
          />

          <YesNoSwitch onChange={toggleValue('shotgunStart')} checked={values.shotgunStart} />
        </Grid>

        {!values.shotgunStart && (
          <Grid className="grid-item" item={true} xs={12}>
            <span className="label">MINUTES BETWEEN TEE TIMES</span>

            <Input
              classes={{ input: 'input-tee-sheet-setup' }}
              label=""
              id="teeFrequency"
              type="number"
              inputProps={{ min: 1 }}
              value={values.teeFrequency}
              onChange={setValue('teeFrequency')}
              hasError={errors.teeFrequency}
            />
          </Grid>
        )}

        <Grid className="grid-item" item={true} xs={12}>
          <span className="label">PLAYERS PER TEE TIME</span>

          <Input
            classes={{ input: 'input-tee-sheet-setup' }}
            label=""
            id="playersPerTee"
            type="number"
            value={values.playersPerTee}
            onChange={setValue('playersPerTee')}
            hasError={errors.playersPerTee}
            inputProps={{ min: 2, max: event.totalPlayers }}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export { TeeSheetSetup };
